import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-resumo-decisao-certa',
  templateUrl: './resumo-decisao-certa.component.html',
  styleUrls: ['./resumo-decisao-certa.component.scss']
})
export class ResumoDecisaoCertaComponent implements OnInit {


  @Input() consulta: any;

  totalRestricoes = 0;
  totalAtencoes = 0;
  totalMultas = 0;
  totalDebitos = 0;
  totalSuccess = 0;
  totalWarning = 0;
  totalDanger = 0;


  itens = {
    restricaoNacional: { label: 'DADOS <strong>NACIONAIS</strong>: RESTRIÇÕES', text: 'NADA CONSTA', status: 'success' },
    restricaoEstadual: { label: 'DADOS <strong>ESTADUAIS</strong>: RESTRIÇÕES ', text: 'NADA CONSTA', status: 'success' },
    multasEstaduais: { label: 'DADOS <strong>ESTADUAIS</strong>: MULTAS', text: 'NADA CONSTA', status: 'success' },
    debitosMultas: { label: 'DADOS <strong>ESTADUAIS</strong>: DÉBITOS', text: 'NADA CONSTA', status: 'success' },
    comunicacaoVendaNacional: { label: 'COMUNICAÇÃO DE VENDA NACIONAL', text: 'NADA CONSTA', status: 'success' },
    comunicacaoVendaEstadual: { label: 'COMUNICAÇÃO DE VENDA ESTADUAL', text: 'NADA CONSTA', status: 'success' },
    historicoRouboFurto: { label: 'HISTÓRICO DE <strong>ROUBO/FURTO</strong>', text: 'NADA CONSTA', status: 'success' },
    rouboFurtoAtivo: { label: 'ROUBO/FURTO <strong>ATIVO</strong>', text: 'NADA CONSTA', status: 'success' },
    indicioSinistro: { label: 'INDÍCIO DE SINISTRO', text: 'NADA CONSTA', status: 'success' },
    indicioSinistro2: { label: 'INDÍCIO DE SINISTRO 2', text: 'NADA CONSTA', status: 'success' },
    leilao1: { label: 'BASE DE LEILÃO 1', text: 'NADA CONSTA', status: 'success' },
    leilao2: { label: 'BASE DE LEILÃO 2', text: 'NADA CONSTA', status: 'success' },
    leilao3: { label: 'BASE DE LEILÃO 3', text: 'NADA CONSTA', status: 'success' },
    decodificacao: { label: 'DECODIFICAÇÃO', text: 'NADA CONSTA', status: 'success' },
    recall: { label: 'RECALL', text: 'NADA CONSTA', status: 'success' },
    renainf: { label: 'RENAINF', text: 'NADA CONSTA', status: 'success' },
    renajud: { label: 'RENAJUD', text: 'NADA CONSTA', status: 'success' },
    duplicidadeMotor: { label: 'DUPLICIDADE DE MOTOR', text: 'NADA CONSTA', status: 'success' },
    remarketing: { label: 'REMARKETING', text: 'NADA CONSTA', status: 'success' },
    gravame: { label: 'GRAVAME', text: 'NADA CONSTA', status: 'success' },
    parecerTecnico: { label: 'PARECER TÉCNICO', text: 'NADA CONSTA', status: 'success' },
    bateu: { label: 'BATEU', text: 'NADA CONSTA', status: 'success' },
  };

  id: any;
  veiculoSucess: any;
  consultaSuccess: any;
  resumoVeiculo: any;
  marcaModelo: any;
  dadosConsulta: any;
  marcaFipe: any;
  anoModelo: any;
  emplacamento: any;
  cor: any;
  placa: any;
  dataCriacao: any;
  usuario: any;
  unidade: any;
  tokenconsulta: any;
  tiposConsulta: any;
  itensAprovados: any;
  itensAlertas: any;
  itensReprovados: any;
  totalItensResumo: any;
  showItensResumo: boolean = false;
  entrada: any;
  nomeConsulta: any;

  constructor() { }

  ngOnInit() {
    this.formatarStatusResumo();
    this.getTotalMultas();
    this.inicializaVariaveis();
    this.setEntrada();

    this.tiposConsulta = this.consulta.consultas;
    this.tiposConsulta.forEach(t => {
      t.tipoConsulta;
    });

    // Dados que são exibidos nas tabelas da view
    this.itensAprovados = this.consulta.dadosResumo.itensAprovados;
    this.itensReprovados = this.consulta.dadosResumo.itensReprovados;
    this.itensAlertas = this.consulta.dadosResumo.itensAlertas;
    this.nomeConsulta = this.consulta.nomeConsulta;

    if(this.itensAprovados || this.itensReprovados || this.itensAlertas) {
      this.totalItensResumo = this.itensAprovados.length + this.itensAlertas.length + this.itensReprovados.length;
    }else {
      this.totalItensResumo = 0;
    }

  }

  inicializaVariaveis(){
    let bins = ['BIN_ESTADUAL', 'BIN_FEDERAL', 'BIN_FEDERAL_RF'];
    this.showItensResumo = this.consulta.decisaoCerta || this.consulta.consultas.some( c => bins.find(bin => bin==c.tipoConsulta) )

    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo != '') {
      this.resumoVeiculo = true;
      this.validaVeiculos(this.consulta.dadosResumo);
      this.validaConsulta(this.consulta);
    }

  }

  validaVeiculos(info) {
    // Validação Veículo - Valida se existe cada campo
    if(info.marcaFipe != null && info.marcaFipe != ''){
      this.marcaFipe = true;
    }
    if(
      info.marcaVeiculo != null && info.marcaVeiculo != '' ||
      info.modeloVeiculo != null && info.modeloVeiculo != ''
      ){
        this.marcaModelo = true;
    }
    if(
      info.anoFabricacao != null && info.anoFabricacao != '' ||
      info.anoModelo != null && info.anoModelo != ''
      ){
        this.anoModelo = true;
    }
    if(info.municipio != null && info.municipio != ''){
      this.emplacamento = true;
    }
    if(info.cor != null && info.cor != ''){
      this.cor = true;
    }

    // Se um desses campos acima for true, mostra o card com o título + a informação dentro ...
    if(this.marcaModelo == true || this.anoModelo == true || this.emplacamento == true || this.cor == true) {
      this.veiculoSucess = true;
    }

  }

  validaConsulta(info) {
    // Validação Dados Consulta - Valida se existe cada campo
    if(info.placaEntrada != null && info.placaEntrada != ''){
      this.placa = true;
    }
    if(info.dataCriacao != null && info.dataCriacao != ''){
      this.dataCriacao = true;
    }
    if(info.usuario != null && info.usuario != ''){
      this.usuario = true;
    }
    if(info.unidade != null && info.unidade != ''){
      this.unidade = true;
    }
    if(info.tokenConsulta != null && info.tokenConsulta != ''){
      this.tokenconsulta = true;
    }
    if(info.id != null && info.id != ''){
      this.id = true;
    }

    // Se um desses campos acima for true, mostra o card com o título + a informação dentro ...
    if(this.placa == true || this.dataCriacao == true || this.usuario == true || this.unidade == true || this.tokenconsulta == true || this.id) {
      this.consultaSuccess = true;
    }
  }

  setEntrada() {
    if(!this.consulta.placaEntrada && !this.consulta.placaPesquisa && this.consulta.cnhEntrada) {
      this.entrada = this.consulta.cnhEntrada;
    }
    if(!this.consulta.placaEntrada && !this.consulta.placaPesquisa && this.consulta.motorEntrada) {
      this.entrada = this.consulta.motorEntrada;
    }
    if(!this.consulta.placaEntrada && !this.consulta.placaPesquisa && this.consulta.chassiEntrada) {
      this.entrada = this.consulta.chassiEntrada;
    }
    if(!this.consulta.placaEntrada && !this.consulta.placaPesquisa && this.consulta.chassiPesquisa) {
      this.entrada = this.consulta.chassiPesquisa;
    }
    if(!this.consulta.placaEntrada && !this.consulta.placaPesquisa && this.consulta.documentoEntrada) {
      this.entrada = this.consulta.documentoEntrada;
    }
  }

  getTotalMultas(){
    if(this.consulta.dadosResumo!=null
        && this.consulta.dadosResumo.qtdMultas!=null && this.consulta.dadosResumo.qtdMultas!=undefined){
       this.totalMultas += this.consulta.dadosResumo.qtdMultas;
    }
    if(this.consulta.binfederalunion!=null
      && this.consulta.binfederalunion.listaMultasRenainf!=null && this.consulta.binfederalunion.listaMultasRenainf!=undefined){
        this.totalMultas += this.consulta.binfederalunion.listaMultasRenainf.length;
    }
  }

  getRestricaoNacional(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.restricoesFederais!=null
      && this.consulta.dadosResumo.posicaoRestricaoNacionao == 'vermelho' && this.consulta.dadosResumo.restricoesFederais>0){
      this.itens.restricaoNacional.status = 'danger';
      this.itens.restricaoNacional.text = 'Registro de restrições federais encontrados : ' +this.consulta.dadosResumo.restricoesFederais ;
      this.totalDanger++;
    }
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.restricoesFederais!=null
      && this.consulta.dadosResumo.posicaoRestricaoNacional == 'amarelo' && this.consulta.dadosResumo.restricoesFederais>0){
      this.itens.restricaoNacional.status = 'warning';
      this.itens.restricaoNacional.text = 'Registro de restrições federais encontrados : ' +this.consulta.dadosResumo.restricoesFederais ;
      this.totalWarning++;
    }
  }

  getRestricaoEstadual(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.restricoesEstaduais!=null
      && this.consulta.dadosResumo.posicaoRestricaoEstadual=='vermelho' && this.consulta.dadosResumo.restricoesEstaduais>0){
      this.itens.restricaoEstadual.status = 'danger';
      this.itens.restricaoEstadual.text = 'Registro de restrições estaduais encontrados: '+this.consulta.dadosResumo.restricoesEstaduais;
      this.totalDanger++;
    }
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.restricoesEstaduais!=null
      && this.consulta.dadosResumo.posicaoRestricaoEstadual=='amarelo' && this.consulta.dadosResumo.restricoesEstaduais>0){
      this.itens.restricaoEstadual.status = 'warning';
      this.itens.restricaoEstadual.text = 'Registro de restrições estaduais encontrados: '+this.consulta.dadosResumo.restricoesEstaduais;
      this.totalWarning++;
    }
  }

  getBateu(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.bateu!=null
      && this.consulta.dadosResumo.bateu>0){
      this.itens.bateu.status = 'danger';
      this.itens.bateu.text = 'Registro encontrados : '+this.consulta.dadosResumo.bateu;
      this.totalDanger++;
    }
  }

  getHistoricoRouboFurto(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.historicoRouboFurto!=null
      && this.consulta.dadosResumo.historicoRouboFurto && !this.consulta.dadosResumo.rouboFurtoAtivo){
      this.itens.historicoRouboFurto.status = 'danger';
      this.itens.historicoRouboFurto.text = 'Registro de histórico de roubo e furto';
      this.totalDanger++;
    }
  }

  getRouboFurtoAtivo(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.rouboFurtoAtivo!=null
      && this.consulta.dadosResumo.rouboFurtoAtivo){
      this.itens.rouboFurtoAtivo.status = 'danger';
      this.itens.rouboFurtoAtivo.text = 'Registro de histórico de roubo e furto';
      this.totalDanger++;
    }
  }

  getComunicacaoVendaNacional(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.comunicacaoVendaNacional!=null
      && this.consulta.dadosResumo.comunicacaoVendaNacional){
        this.itens.comunicacaoVendaNacional.status = 'warning';
        this.itens.comunicacaoVendaNacional.text = 'Registro de comunicação de venda federal';
        this.totalWarning++;
    }
  }

  getComunicacaoVendaEstadual(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.comunicacaoVendaEstadual!=null
      && this.consulta.dadosResumo.comunicacaoVendaEstadual){
        this.itens.comunicacaoVendaEstadual.status = 'warning';
        this.itens.comunicacaoVendaEstadual.text = 'Registro de comunicação de venda estadual';
        this.totalWarning++;
    }
  }

  getIndicioSinistro(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.indicioSinistro!=null
      && this.consulta.dadosResumo.indicioSinistro){
        this.itens.indicioSinistro.status = 'danger';
        this.itens.indicioSinistro.text = 'Registro de sinistro encontrado';
        this.totalDanger++;
    }
  }

  getIndicioSinistro2(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.indicioSinistro2!=null
      && this.consulta.dadosResumo.indicioSinistro2){
      this.itens.indicioSinistro2.status = 'danger';
      this.itens.indicioSinistro2.text = 'Registro de sinistro 2 encontrado';
      this.totalDanger++;
      }
  }

  getLeilao(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.leilao1!=null
      && this.consulta.dadosResumo.leilao1>0){
      this.itens.leilao1.status = 'danger';
      this.itens.leilao1.text = 'Registro encontrados : '+this.consulta.dadosResumo.leilao1;
      this.totalDanger++;
    }
  }

  getLeilao2(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.leilao2!=null
      && this.consulta.dadosResumo.leilao2>0){
      this.itens.leilao2.status = 'danger';
      this.itens.leilao2.text = 'Registro encontrados : '+this.consulta.dadosResumo.leilao2;
      this.totalDanger++;
    }
  }

  getLeilao3(){
    if(this.consulta.dadosResumo != null && this.consulta.dadosResumo.leilao3!=null
      && this.consulta.dadosResumo.leilao3>0){
      this.itens.leilao3.status = 'danger';
      this.itens.leilao3.text = 'Registro encontrados : '+this.consulta.dadosResumo.leilao3;
      this.totalDanger++;
    }
  }

  getDecodificacao(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.decodificacaoCorreta != null
      && !this.consulta.dadosResumo.decodificacaoCorreta){
      this.itens.decodificacao.status = 'warning';
      this.itens.decodificacao.text = 'Erro na decodificação';
        this.totalAtencoes++;
    }
  }

  getRecall(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.recall != null
      && this.consulta.dadosResumo.recall > 0){
      this.itens.recall.status = 'warning';
      this.itens.recall.text = 'Registros encontrados : '+this.consulta.dadosResumo.recall;
      this.totalWarning++;
    }
  }

  getMultasRenainf(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.multasRenainf != null
      && this.consulta.dadosResumo.multasRenainf > 0){
      this.itens.renainf.status = 'warning';
      this.itens.renainf.text = 'Registros encontrados : '+this.consulta.dadosResumo.multasRenainf;
      this.totalWarning++;
    }
  }

  getRenajud(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.renajud != null
      && this.consulta.dadosResumo.renajud > 0){
      this.itens.renajud.status = 'danger';
      this.itens.renajud.text = 'Registros encontrados : '+this.consulta.dadosResumo.renajud;
      this.totalDanger++;
    }
  }

  getDuplicidadeMotor(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.motorDuplicado != null
      && this.consulta.dadosResumo.motorDuplicado > 0){
      this.itens.duplicidadeMotor.status = 'warning';
      this.itens.duplicidadeMotor.text = 'Registros encontrados : '+this.consulta.dadosResumo.motorDuplicado;
      this.totalWarning++;
    }
  }

  getRemarketing(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.remarketing != null
      && this.consulta.dadosResumo.remarketing > 0){
      this.itens.remarketing.status = 'danger';
      this.itens.remarketing.text = 'Registros encontrados : '+this.consulta.dadosResumo.remarketing;
      this.totalDanger++;
    }
  }

  getGravame(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.possuiGravame != null
      && this.consulta.dadosResumo.possuiGravame){
      this.itens.gravame.status = 'warning';
      this.itens.gravame.text = 'Registros encontrados';
      this.totalWarning++;
    }
  }


  getParecerTecnico(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.parecerTecnico != null
      && this.consulta.dadosResumo.parecerTecnico){
      this.itens.parecerTecnico.status = "warning";
      this.itens.parecerTecnico.text = "Registros encontrados";
      this.totalWarning++;
    }
  }

  getMultasEstaduais(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.multasEstaduais != null
      && this.consulta.dadosResumo.multasEstaduais){
      this.itens.multasEstaduais.status = "danger";
      this.itens.multasEstaduais.text = "Registros encontrados";
      this.totalDanger++;
    }
  }

  getDebitosMultas(){
    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.debitosEstaduais != null
      && this.consulta.dadosResumo.debitosEstaduais){
      this.itens.debitosMultas.status = "warning";
      this.itens.debitosMultas.text = "Registros encontrados";
      this.totalWarning++;
    }
  }



  formatarStatusResumo() {


    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.qtdDebitos!=null ){
      this.totalDebitos = this.consulta.dadosResumo.qtdDebitos;
    }

    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.qtdMultas!=null ){
      this.totalMultas = this.consulta.dadosResumo.qtdMultas;
    }

    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.qtdPontosAtencao!=null ){
      this.totalAtencoes = this.consulta.dadosResumo.qtdPontosAtencao;
    }

    if(this.consulta.dadosResumo!=null && this.consulta.dadosResumo.qtdRestricoes!=null ){
      this.totalRestricoes = this.consulta.dadosResumo.qtdRestricoes;
    }

    this.getRestricaoNacional()

    this.getRestricaoEstadual()

    this.getBateu()

    this.getHistoricoRouboFurto()

    this.getRouboFurtoAtivo()

    this.getComunicacaoVendaNacional()

    this.getComunicacaoVendaEstadual()

    this.getIndicioSinistro()

    this.getIndicioSinistro2()

    this.getLeilao()

    this.getLeilao2()

    this.getLeilao3()

    this.getDecodificacao()

    this.getRecall()

    this.getMultasRenainf()

    this.getRenajud()

    this.getDuplicidadeMotor()

    this.getRemarketing()

    this.getGravame()

    this.getParecerTecnico()

    this.getMultasEstaduais()

    this.getDebitosMultas();

  }

}
